import type { ProjectData } from '../../types';
import Component from './content.mdx';

const data: ProjectData = {
    slug: 'metaeditor',
    title: 'MetaEditor for Pixel Streaming',
    description: 'MetaEditor is a web-based tool that allows users to create and manage interactive 3D content for Pixel Streaming applications. It provides a user-friendly interface to customize 3D scenes, add interactivity, and configure streaming settings.',
    fileName: 'content.mdx',
    markdown: Component,
    info: {
        stack: [
            'React',
            'TypeScript',
            'Material-UI',
            'Node.js',
            'Next.js',
            'Docker',
            'PostgreSQL',
        ],
        url: 'https://metaeditor.unrealos.com',
    },
};

export default data;
